var defaultHTMLElements = ['a', 'abbr', 'acronym', 'address', 'applet', 'b', 'big', 'blockquote', 'body', 'caption', 'center', 'cite', 'code', 'dd', 'del', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'font', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'html', 'i', 'iframe', 'img', 'ins', 'kbd', 'label', 'legend', 'li', 'object', 'ol', 'p', 'pre', 'q', 's', 'samp', 'small', 'span', 'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'tt', 'u', 'ul', 'var'];
var resetStyles = () => ({
  [defaultHTMLElements.join(',')]: {
    background: 'transparent',
    border: 0,
    fontSize: '100%',
    margin: 0,
    outline: 0,
    padding: 0,
    verticalAlign: 'baseline'
  },
  ':focus': {
    outline: 0
  },
  body: {
    lineHeight: 1,
    msOverflowStyle: 'scrollbar' // Enforce the use of standard scrollbar behavior on IE
  },
  button: {
    margin: 0
  },
  'blockquote, q': {
    quotes: 'none',
    '&::before, &::after': {
      content: 'none'
    }
  },
  ins: {
    textDecoration: 'none'
  },
  del: {
    textDecoration: 'line-through'
  },
  // tables still need 'cellspacing="0"' in the markup
  table: {
    borderCollapse: 'collapse',
    borderSpacing: 0
  },
  // This code is to remove cross(x) from webkit browsers
  'input[type="search"]::-webkit-search-cancel-button': {
    display: 'none'
  },
  // This code is to remove cross(x) from internet explorer
  'input[type="search"]::-ms-clear': {
    display: 'none'
  },
  // This code is to remove cross(x) on all input text from internet explorer
  'input[type=text]::-ms-clear': {
    display: 'none'
  },
  // This code is to remove reveal(eye) on password input from internet explorer
  'input[type=password]::-ms-reveal': {
    display: 'none'
  }
});
export default resetStyles;